import { Avatar, Button, Input } from 'antd';
import React, { useEffect, useState } from 'react';
import { CiSearch } from 'react-icons/ci';
import { NavLink } from 'react-router-dom';
import { getHighlightedText, getInitials } from '../../utils';
import { IoMdAdd } from 'react-icons/io';
import { getRoutes } from '../../constants/Routes';
import { isAdmin, isSuperAdmin } from '../../helper';
import AddShop from '../AddShop';
import useRestaurants from '../../hooks/useRestaurants';

const Aside = ({ onClose }) => {
  const { restaurants } = useRestaurants();
  const [filterRestaurants, setFilterRestaurants] = useState([]);
  const [search, setSearch] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearch(query);
    const filtered = restaurants?.filter((restaurant) =>
      restaurant.title.toLowerCase().includes(query)
    );
    setFilterRestaurants(filtered);
  };

  useEffect(() => {
    setFilterRestaurants(restaurants);
  }, [restaurants]);

  return (
    <aside className="Aside">
      <div className="Aside__Top">
        <Input
          placeholder="Search..."
          size="large"
          allowClear
          suffix={<CiSearch />}
          onChange={handleSearch}
        />
      </div>
      <div className="Aside__Mid">
        <div className="Aside__Mid__Menu">
          {filterRestaurants?.length ? (
            filterRestaurants?.map((item) => {
              return (
                <NavLink
                  key={item.id}
                  to={getRoutes().restaurant_detail.route(item.id)}
                  className="aside-menu"
                  title={item?.title}
                  onClick={onClose}
                >
                  <Avatar shape='square' children={getInitials(item.title)} size={35} style={{ flexShrink: 0 }} />
                  <div className="name truncate">{getHighlightedText(item?.title, search)}</div>
                </NavLink>
              );
            })
          ) : (
            <span style={{ textAlign: 'center' }}>No Item</span>
          )}
        </div>
      </div>
      {(isSuperAdmin() || isAdmin()) && (
        <div className="Aside__Bottom">
          <Button type="primary" block icon={<IoMdAdd />} onClick={() => setIsOpen(true)}>
            Add Site
          </Button>
        </div>
      )}

      {isOpen && <AddShop open={isOpen} onClose={() => setIsOpen(false)} />}
    </aside>
  );
};

export default Aside;
